

































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
const { AgGridVue } = require('ag-grid-vue');
import {
    GridOptions,
    GridApi,
    ColumnApi,
    GridReadyEvent,
    RowSelectedEvent,
} from 'ag-grid-community';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import { LoadingService } from '@/services/loadingService';
import store from '@/store';
import Confirmation from '@/components/Confirmation.vue';

@Component({
    components: {
        CabeceraModal, AgGridVue,
        'app-confirmacion': Confirmation,
    },
})
export default class AsignacionClienteGpsModal extends Vue {
    // States ##################################################

    // Props
    @Prop({ default: false }) openModal: boolean;
    @Prop({ default: {} }) gps: any;

    // Vars globales 
    $snotify: any;

    // instancia para llamar al backend
    axiosPy: AxiosVue = new AxiosVue(ServicioProxy.Metabase);

    haveChanges: boolean = false;
    searchClientTF: string = "";
    loadingService = new LoadingService();

    // Vars para abrir o cerrar modales
    dialogConfirm: boolean = false;

    // vars asociados a la grilla
    gridOptions: GridOptions;
    gridApi: GridApi;
    columnApi: ColumnApi;
    clientSelected: any = {};

    // Watchs #############################################################################################################

    // Función que se gatilla al abrir el modal
    @Watch('openModal')
    onOpenModal() {
        if (this.openModal) {
            // Vars que se reinician cuando se abre el modal (filtro de búsqueda de cliente)
            this.searchClientTF = "";
            this.handleSearchClient();

            // Se valida si existe los clientes en caché, de ser así, no se hace una petición de nuevo a la db
            // Var para controlar si existe o no clientes en caché
            let clientCache: boolean = false;
            try {
                // Se obtiene los clientes de caché, del param "clients"
                let clients = this.$store.getters.getClientsTrack;
                if (clients.length > 0) {
                    // Si hay clientes, los pone en la grilla
                    this.gridApi.setRowData(clients);
                    clientCache = true;
                }
            } catch (error) {
                console.log(error)
            }

            // En caso de no tener clientes en caché, hace la petición al servicio
            if (!clientCache) {
                this.getClients();
            }
        }
    }

    // Functions ########################################################################################################

    // El constructor hará la carga inicial de la grilla, aplicando la config en la variable gridOptions 
    constructor() {
        super();
        // Configuración de la grilla
        this.gridOptions = {
            // Columnas
            columnDefs: [{
                headerName: '',
                field: 'checked',
                width: 70,
                minWidth: 70,
                maxWidth: 70,
                pinned: 'left',
                checkboxSelection: true,
                suppressMenu: true,
                filter: false,
                suppressMovable: true,
                sortable: false,
                resizable: false,
                lockVisible: true,
                cellStyle: { textAlign: 'center' },
            }, {
                headerName: 'Cliente',
                field: 'nombre',
                sortable: true,
                resizable: true,
                minWidth: 80,
                lockPinned: true,
            },
            {
                headerName: 'Rut',
                field: 'rut',
                sortable: true,
                resizable: true,
                minWidth: 80,
                lockPinned: true,
            },
            {
                headerName: 'Giro',
                field: 'Giro',
                sortable: true,
                resizable: true,
                minWidth: 80,
                lockPinned: true,
            },
            {
                headerName: 'Dirección',
                field: 'Direccion',
                sortable: true,
                resizable: true,
                minWidth: 80,
                lockPinned: true,
            },
            {
                headerName: 'Calle',
                field: 'Calle',
                sortable: true,
                resizable: true,
                minWidth: 80,
                lockPinned: true,
            }, {
                headerName: 'Región',
                field: 'regionTexto',
                sortable: true,
                resizable: true,
                minWidth: 80,
                lockPinned: true,
            },
            {
                headerName: 'Telefono',
                field: 'telefono1',
                sortable: true,
                resizable: true,
                minWidth: 80,
                lockPinned: true,
            },
            ],
            rowSelection: 'single',
            pagination: true,
            paginationPageSize: 50,
            cacheBlockSize: 10000,
            paginationAutoPageSize: false,
            onGridSizeChanged: event => {
                event.api.sizeColumnsToFit();
            },
            suppressRowClickSelection: true,
            suppressCellSelection: false,
            // Con la prop onRowSelected, se llamará a la función onRowSelected cuando se clickee o seleccione sobre un cliente
            onRowSelected: this.onRowSelected,
            // Con la prop onGridReady, se llamará a la función onGridReady cuando la grilla esté montada en el DOM, para cargar la data inicial
            onGridReady: this.onGridReady,
            suppressCopyRowsToClipboard: true,
            overlayNoRowsTemplate: 'No hay filas para mostrar',
            blockLoadDebounceMillis: 350,
            columnTypes: {},
            suppressCsvExport: false,
            suppressExcelExport: true,
        };
    }

    // Función que se llama cuando la grilla está totalmente montada en el DOM
    onGridReady(params: GridReadyEvent) {
        // variables para acceder facilmente a los props de la grilla
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        // Se inicializa la grilla con una lista vacia (para evitar que la grilla inicie con un loading)
        this.gridApi.setRowData([]);
        this.gridApi.setDomLayout('autoHeight');
    }

    onRowSelected(event: RowSelectedEvent) {
        // Activa el botón guardar si hay al menos una fila seleccionada ; Desactiva el botón guardar si no hay al menos una fila seleccionada
        this.haveChanges = this.gridApi.getSelectedRows().length > 0 ? true : false;
        if(this.haveChanges){
            this.clientSelected = this.gridApi.getSelectedRows()[0];
        }
    }

    // Función para obtener los clientes y guardarlos
    async getClients() {
        this.gridApi.setRowData([]);
        this.loadingService.showLoading();
        await this.axiosPy.http.post('Metabase/PostgenericA/cliente/getAllClientes', {})
            .then((response: any) => {
                // Si la respuesta es "1", el servicio funcionó correctamente
                if (response.data.CODIGO_RESPUESTA == '1') {
                    // le paso la data a la grilla
                    this.gridApi.setRowData(response.data.data);
                    // Se agrega los clientes al caché
                    store.commit('setClientsTrack', response.data.data);
                } else {
                    this.$snotify.error(response.data.MENSAJE_RESPUESTA);
                }
            })
            .catch((error: any) => {

            })
            .finally(() => {
                this.loadingService.hideLoading();
            })
    }

    // Función para buscar el texto ingresado en todas las columnas de la grilla
    handleSearchClient() {
        this.gridApi.setQuickFilter(this.searchClientTF);
        this.gridApi.setDomLayout('autoHeight');
    }

    // Función para cerrar el modal
    handleCLoseModal() {
        this.$emit("closeModal");
    }

    // Función que se gatilla cuando se presiona el botón "Guardar"
    handleBtnSave(){
        this.dialogConfirm = true;
    }

    // Función de escucha cuando el usuario confirma la asignación del gps por medio del modal
    confirmCallbackSave(val: boolean) {
        this.dialogConfirm = false;
        if (val) {
            this.handleSave();
        }
    }

    // Función para guardar los cambios (asociar gps)
    handleSave() {
        const clientSelected = this.gridApi.getSelectedRows()[0];
        this.$emit("handleSave", { clientSelected: clientSelected, gps: this.gps })
    }

}
